import React, { useState } from "react";
import { Button, Input, Form, Row, Col } from "antd";
import lang from "../helper/lang";
import { MinusCircleOutlined } from "@ant-design/icons";

const FAQForm = ({ onSubmit }) => {
  const [faqs, setFaqs] = useState([{ question: "", answer: "" }]);
  const [form] = Form.useForm();

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const updatedFaqs = [...faqs];
    updatedFaqs[index][name] = value;
    setFaqs(updatedFaqs);
  };

  const handleAddFaq = () => {
    setFaqs([...faqs, { question: "", answer: "" }]);
  };

  const handleRemoveFaq = (index) => {
    const updatedFaqs = faqs.filter((_, i) => i !== index);
    setFaqs(updatedFaqs);
  };

  const handleSubmit = () => {
    onSubmit(faqs);
    form.resetFields();
    setFaqs([{ question: "", answer: "" }]); // Reset the faqs state
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      {faqs.map((faq, index) => (
        <div key={index} style={{ marginBottom: "10px" }}>
          <Row gutter={[16, 0]} className="margin-no-cssj">
            <Col span={20} md={12}>
              <Form.Item
                label={`FAQ ${index + 1}`}
                name={`faq_${index}`}
                rules={[{ required: true, message: "Please enter the FAQ" }]}
              >
                <div style={{ marginBottom: "10px" }}>
                  <Input
                    name="question"
                    placeholder={lang("Enter your question")}
                    value={faq.question}
                    onChange={(e) => handleChange(index, e)}
                    style={{ marginBottom: "8px" }}
                  />
                  <Input
                    name="answer"
                    placeholder={lang("Enter your answer")}
                    value={faq.answer}
                    onChange={(e) => handleChange(index, e)}
                  />
                </div>
              </Form.Item>
            </Col>
            <Col span={4} md={2}>
              <Button
                type="danger"
                icon={<MinusCircleOutlined />}
                onClick={() => handleRemoveFaq(index)}
              />
            </Col>
          </Row>
        </div>
      ))}
      <div className="add-more-faqqqq">
        <Button
          type="dashed"
          onClick={handleAddFaq}
          className="faq-btn-2 faq-btn-6"
        >
          {lang("Add More FAQ")}
        </Button>
        <Button
          type="primary"
          className="faq-btn-5 faq-btn-6"
          htmlType="submit"
        >
          {lang("Submit")}
        </Button>
      </div>
    </Form>
  );
};

export default FAQForm;
